import { useEffect } from "react";
import { request } from "utils/request";
export function isApp() {
  let wurl = window.location.href;
  let url = new URL(wurl);
  let params = url.searchParams;
  // url.search = params.toString();
  // let getUrl = url.toString();
  let path = params.get("platform");
  if (path === "ios" || path === "android") {
    return true;
  } else if (isNativeApp()) {
    return true;
  }
  return false;
}

function isNativeApp() {
  try {
    return !!window.Android || !!window.isNativeApp;
  } catch (err) {
    return false;
  }
}

export function isiOSApp() {
  try {
    return !!window.isNativeApp;
  } catch (err) {
    return false;
  }
}

export function isAndroidApp() {
  try {
    return !!window.Android;
  } catch (err) {
    return false;
  }
}

export function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

export function decodeToken(token) {
  let wurl = window.location.href;
  let url = new URL(wurl);
  let params = url.searchParams;
  let path = params.get("data");

  if (path) {
    var user_data = JSON.parse(atob(path));
    let jwtData = parseJwt(user_data?.jwtAccessToken);
    localStorage.setItem("user", JSON.stringify(user_data?.user));
    let reudscd_string = btoa(
      user_data?.user?.userId +
      "#" +
      user_data?.refreshToken +
      "#" +
      user_data?.jwtAccessToken
    );
    let domain = window.location.hostname;
    if (window.location.hostname != "localhost") {
      domain = process.env.REACT_APP_DOMAIN;
    }
    document.cookie =
      process.env.REACT_APP_DEV_COOKIE + "=" +
      reudscd_string +
      "; expires=" +
      new Date(jwtData?.exp * 1000).toUTCString() +
      "; path=/; domain=" +
      domain;
    // document.cookie = "ReUDscD="+ reudscd_string +"; expires=" + new Date(jwtData?.exp* 1000).toUTCString() +"; path=/; doma";
  }
}

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function decodeCookies(name) {
  var cookieData = getCookie(name);
  var decodeCookiesData = atob(cookieData);
  var ca = decodeCookiesData.split("#");
  return {
    user_id: ca[0],
    refersh_token: ca[1],
    jwt_token: ca[2],
  };
}

export function RemoveCookie(name, path) {
  // console.log(`name`, name);
  let domain = window.location.hostname;
  if (window.location.hostname != "localhost") {
    domain = process.env.REACT_APP_DOMAIN;
  }
  console.log(`window.location.hostname`, window.location.hostname);
  console.log(`process.env.REACT_APP_DOMAIN`, process.env.REACT_APP_DOMAIN);
  console.log(`name`, name);
  console.log(`domain`, domain);
  console.log(`path`, path);

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};  domain=${domain}`;
}

export function redirectToLogin(pathname) {
  let domain = window.location.hostname;
  if (window.location.hostname != "localhost") {
    domain = process.env.REACT_APP_DOMAIN;
  }
  document.cookie =
    process.env.REACT_APP_DEV_COOKIE + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + domain;
  window.open(
    process.env.REACT_APP_HOME_REDIRECTION +
    "/in/en/app-login/?callbackUrl=" +
    process.env.REACT_APP_REDIRECT_URL +
    pathname +
    "&app_id=4",
    "_self"
  );
}

export function redirectAdmin() {
  RemoveCookie(process.env.REACT_APP_ADMIN_DEV_COOKIE, '/')
  window.open(process.env.REACT_APP_REDIRECT_URL + '/admin/user-login', "_self")
}

export function redirectOperator() {
  RemoveCookie(process.env.REACT_APP_OPERATOR_DEV_COOKIE, '/partner')
  window.open(process.env.REACT_APP_REDIRECT_URL + '/partner/login-account', "_self")
}

export function getUserByUrl() {
  let wurl = window.location.href;
  let url = new URL(wurl);
  let finalPath = url.pathname?.split("/");
  // console.log(finalPath)
  return finalPath[1]
}

export function withOutLoginUrl() {
  let wurl = window.location.href;
  let url = new URL(wurl);
  let finalPath = url.pathname?.split("/");
  // console.log(finalPath)
  const routes = ['login-account',
    "thankyou",
    "partner-dashboard",
    "rental",
    "partner-setup",
    "reset-password",
    "forgot-password",
    "partner-faq",
    "partner-pre-onboarding",
    "tempOnboarding-Operator",
    "partner-home"
  ]
  if (routes.includes(finalPath[2])) {
    return false
  } else {
    return true
  }
}

export function withOutAdminLoginUrl() {
  let wurl = window.location.href;
  let url = new URL(wurl);
  let finalPath = url.pathname?.split("/");
  // console.log(finalPath)
  const routes = ['user-login',
    "forgetpassword",
    "resetpassword"
  ]
  if (routes.includes(finalPath[2])) {
    return false
  } else {
    return true
  }
}